import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {PlaylistPerformances, PlaylistPerfData} from './types';
import type {
	AnalyticFilters,
	AnalyticsDemographics,
	AnalyticsMap,
} from '../types';

const {get} = requestWrapper;

const requests = {
	getPerformances: (id: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<PlaylistPerformances>>(endpoints.performances(id), {
			params: filters,
		}),
	getTrackPerformance: (id: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<PlaylistPerfData>>(endpoints.trackPerformance(id), {
			params: filters,
		}),
	getMap: (id: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<AnalyticsMap>>(endpoints.map(id), {
			params: filters,
		}),
	getDemographics: (id: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<AnalyticsDemographics>>(
			endpoints.demographics(id),
			{
				params: filters,
			},
		),
};

export default requests;
